import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LockKeyhole } from "lucide-react";
import { api, setAdminToken } from "../lib/api";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { password });
      setAdminToken(res.data.token);
      navigate("/admin");
    } catch (err) {
      toast.error("Неверный пароль");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <Card className="w-full max-w-sm shadow-lg">
        <CardHeader className="text-center">
          <div className="mx-auto w-12 h-12 rounded-xl bg-[hsl(var(--primary))] flex items-center justify-center mb-2">
            <LockKeyhole className="text-white" size={24} />
          </div>
          <CardTitle className="font-display">NORD — Админ</CardTitle>
          <CardDescription>Панель управления платежами СБП</CardDescription>
        </CardHeader>
        <CardContent>
          <form data-testid="admin-login-form" onSubmit={submit} className="flex flex-col gap-3">
            <Input
              data-testid="admin-password-input"
              type="password"
              placeholder="Пароль"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
            />
            <Button data-testid="admin-login-submit-button" type="submit" disabled={loading || !password} className="bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/90">
              {loading ? "Вход…" : "Войти"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
